interface ZoomReconnectBannerState {
  enabled: boolean;
  isAdmin: boolean;
  isSandbox: boolean;
  // Tokens have loaded, a Zoom token is invalid, and the banner isn't dismissed.
  reconnectPending: boolean;
}

/**
 * Whether to show the Zoom reconnect banner. Only an admin can reconnect Zoom
 * for the account. A sandbox is a copy of a live account and may carry a
 * copied reconnect status it can't act on, so it never shows the banner.
 */
export const showZoomReconnectBanner = ({
  enabled,
  isAdmin,
  isSandbox,
  reconnectPending
}: ZoomReconnectBannerState): boolean =>
  enabled && isAdmin && !isSandbox && reconnectPending;
